/* eslint-disable */
import React from "react";
import IphoneVideo, { DEFAULT_IPHONE_VIDEO_PATH, DEFAULT_IPHONE_POSTER_PATH } from "../IphoneVideo";
import profileMashup from "../../images/profileMashup.png";

export default function Hero({
  title = "Hair restoration without fear",
}) {
  return (
    <div className="">
      <div>
        {/* Responsive hero: stacked on mobile, two columns on lg+ */}
        <div className="w-3/4 mx-auto px-4 mt-8 lg:mt-14">
          <div className="flex flex-col items-center gap-y-8 lg:grid lg:grid-cols-12 lg:items-center lg:gap-y-0 lg:gap-x-3">
            {/* LEFT: iPhone frame - contained & centered */}
            <div className="w-full lg:col-span-6 flex justify-center lg:justify-start min-w-0">
              <div className="relative rounded-xl overflow-hidden w-full mx-auto max-w-[240px] md:max-w-[280px]">
                <IphoneVideo
                  className="block h-full md:h-auto w-auto mx-auto"
                  videoPath={DEFAULT_IPHONE_VIDEO_PATH}
                  posterPath={DEFAULT_IPHONE_POSTER_PATH}
                  autoplayDelayMs={100}
                />
              </div>
            </div>

            {/* RIGHT: Title + description + CTA + info box */}
            <div className="w-full lg:col-span-6 text-center lg:text-left">
              {title && (
                <h1 className="font-extrabold leading-tight text-3xl md:text-4xl lg:text-5xl">
                  {title}
                </h1>
              )}

              {/* 1) Description */}
              <p className="mt-4 text-base md:text-lg text-gray-600">

              </p>

              {/* 2) Button to /onboarding */}
              <div className="mt-6">
                <a
                  href="/onboarding"
                  className="inline-flex items-center rounded-xl px-5 py-3 border text-white bg-gray-900"
                >
                  <span className="whitespace-nowrap leading-none text-[clamp(13px,3.8vw,16px)]">
                    Get your confidence back →
                  </span>
                </a>
              </div>

              {/* 3) Box with two columns (image + small text) - stacks on mobile */}
              <div className="mt-8 rounded-2xl">
                <div className="grid grid-cols-1 sm:grid-cols-[auto_1fr] gap-y-2 sm:gap-y-0 sm:gap-x-3">
                  {/* Left: image (using poster as a safe placeholder) */}
                  <img
                    src={profileMashup}
                    alt="Preview"
                    className="max-w-[80px] rounded-lg mx-auto sm:mx-0"
                    loading="lazy "
                  />

                  {/* Right: small text */}
                  <div className="text-sm text-gray-600 font-medium text-center sm:text-left sm:self-center">
                    Join 1,000+ hair loss winners
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
